import { graphql } from "gatsby";
import React from "react";
import { Container, Row, Col, Table } from "react-bootstrap";
import Layout from "../components/layout/MainLayout";
import { Chapter } from "../classes/Chapter";
import { Page } from "../classes/Page";
import get from "lodash/get";
import { H1 } from "../components/common";
import { WMKLink } from "wmk-lib";

export const scrubTitle = (title) => title.replace("2020: ", "");

const SitemapPage = ({ data }) => {
  const chapters = data.chapters.edges.map((e) => new Chapter(e.node));
  const pages = data.pages.edges.map((e) => new Page(e.node));
  return (
    <Layout>
      <Container>
        <Row>
          <Col style={{ padding: "3vh 0" }}>
            <H1>Sitemap</H1>
            <Table>
              <tbody>
                {pages.map((p, i) => {
                  const hasChapters = get(p, `block.menuItems`, []).length;
                  const slug = get(p, `slug`) === "home" ? "" : get(p, `slug`);
                  return (
                    <tr key={p.title + i}>
                      <td>
                        <Container>
                          <Row>
                            <Col>
                              <h2 title={"/" + slug}>
                                <WMKLink to={`/${slug}`}>{p.title}</WMKLink>
                              </h2>
                            </Col>
                          </Row>
                          {hasChapters ? (
                            <Row style={{ paddingLeft: "3vh" }}>
                              <Col>
                                {chapters.map((chapter, i) => {
                                  const topics = get(chapter, `topics`, []);
                                  const hasTopics = topics.length;
                                  const chapterSlug = get(chapter, `slug`);
                                  return (
                                    <>
                                      <div key={chapter.title + i}>
                                        <WMKLink to={`/${chapterSlug}`}>
                                          <h4>{scrubTitle(chapter.title)}</h4>
                                        </WMKLink>
                                      </div>
                                      {hasTopics ? (
                                        <Row
                                          className="flex-column"
                                          style={{ paddingLeft: "3vh" }}
                                        >
                                          {topics.map((t, i) => {
                                            const modules = get(
                                              t,
                                              `modules`,
                                              []
                                            );
                                            const hasModules = modules.length;
                                            const topicSlug = get(t, `slug`);
                                            return (
                                              <Col key={t.title + i}>
                                                <WMKLink
                                                  to={`/${chapterSlug}/${topicSlug}`}
                                                >
                                                  <h5>{t.title}</h5>
                                                </WMKLink>
                                                {hasModules ? (
                                                  <Row
                                                    style={{
                                                      paddingLeft: "3vh",
                                                    }}
                                                    className="flex-column"
                                                  >
                                                    {modules.map((m, i) => {
                                                      return (
                                                        <Col key={m.title + i}>
                                                          <em>{m.title}</em>
                                                        </Col>
                                                      );
                                                    })}
                                                  </Row>
                                                ) : null}
                                              </Col>
                                            );
                                          })}
                                        </Row>
                                      ) : null}
                                    </>
                                  );
                                })}
                              </Col>
                            </Row>
                          ) : null}
                        </Container>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </Table>
          </Col>
        </Row>
      </Container>
    </Layout>
  );
};

export default SitemapPage;

export const query = graphql`
  {
    menu: contentfulMenus(title: { eq: "Hamburger: Main" }) {
      ...NodeMenuFields
    }
    pages: allContentfulPages {
      edges {
        node {
          ...NodePagesFields
        }
      }
    }
    chapters: allContentfulChapters(filter: { title: { regex: "/2020/" } }) {
      edges {
        node {
          ...NodeChaptersFields
        }
      }
    }
  }
`;
